<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <div class="input-group mb-3">
        <input type="text" class="form-control" [(ngModel)]="editPrompt" placeholder="Image edit instructions" i18n-placeholder>
        <button type="button" class="btn btn-primary" (click)="edit()" i18n>Edit</button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li><button type="button" class="dropdown-item" (click)="discard()" i18n>Discard changes</button></li>
        </ul>
        <button type="button" class="btn btn-secondary" data-bs-toggle="dropdown"><fa-icon [icon]="fa.faEllipsis"></fa-icon></button>
    </div>
    <div class="position-relative">
        <div style="position: absolute; top: 0.5rem; left: 1rem; background-color: rgba(0, 0, 0, 0.5); color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem;">
            <span *ngIf="index == -1" i18n>Main picture</span>
            <span *ngIf="index != -1">{{ product.name }}</span>
            <span *ngIf="updating" class="spinner-border spinner-border-sm text-light ms-2" role="status"></span>
        </div>
    <img [src]="picture" style="max-width: 100%; width: 100%;">
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="updating" (click)="previous()" i18n>Previous</button>
    <button type="button" class="btn btn-primary" [disabled]="updating" (click)="next()" i18n>Next</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>